import { VFlow } from 'bold-ui'
import React from 'react'

import { AcompanhamentoPreNatalTabs } from './AcompanhamentoPreNatalTabs'
import { AntecedentesObstetricosCard } from './components/AntecedentesObstetricosCard'

interface AcompanhamentoPreNatalContentProps {
  prontuarioId: ID
  atendimentoId: ID
  cidadaoId: ID
  dataReferencia: Instant
  vacinacaoPath: string
  agendamentosPath: string
}

export function AcompanhamentoPreNatalContent(props: AcompanhamentoPreNatalContentProps) {
  const { prontuarioId, atendimentoId, cidadaoId, dataReferencia, vacinacaoPath, agendamentosPath } = props

  return (
    <VFlow>
      <AntecedentesObstetricosCard prontuarioId={prontuarioId} />
      <AcompanhamentoPreNatalTabs
        cidadaoId={cidadaoId}
        prontuarioId={prontuarioId}
        atendimentoId={atendimentoId}
        dataReferencia={dataReferencia}
        vacinacaoPath={vacinacaoPath}
        agendamentosPath={agendamentosPath}
      />
    </VFlow>
  )
}
